<script lang="ts" setup>
import type { DetailsRedSpan, ElementsParameters } from '@autobid/ui/types/components/CarDetails'

interface Props {
  parameters: ElementsParameters
  fullWidth?: boolean
}

defineProps<Props>()

const isPdfPage = inject('isPdfPage', false)

function isLink(value: string | Array<string | DetailsRedSpan>) {
  if (Array.isArray(value))
    return false

  if (typeof value !== 'string')
    return

  return value.startsWith('http')
}
</script>

<template>
  <table class="w-full border-collapse">
    <slot name="before" />

    <tbody>
      <template v-if="fullWidth">
        <tr
          v-for="([label, value], parameterNo) in parameters"
          :key="label"
          class="align-top"
        >
          <td
            colspan="2"
            class="pr-2"
            :style="isPdfPage ? 'width:100%;' : undefined"
          >
            <p
              class="block"
              :class="{ 'font-bold': !isPdfPage, 'mt-4': parameterNo > 0 }"
              :style="
                isPdfPage
                  ? `font-weight:700;margin-top:${
                    parameterNo > 0 ? '15px' : '4px'
                  }4px`
                  : undefined
              "
            >
              {{ label }}:
            </p>

            <template
              v-for="(text, index) in Array.isArray(value) ? value : [value]"
              :key="`${text}-text`"
            >
              <SectionsDetailsElementsText
                v-if="Array.isArray(text)"
                :label="text[0]"
                :text="text[1]"
              />
              <SectionsDetailsElementsText v-else :label="label" :text="text" />
              <br v-if="Array.isArray(value) && index < value.length - 1">
            </template>
          </td>
        </tr>
      </template>

      <template v-else>
        <tr v-for="[label, value] in parameters" :key="label" class="align-top">
          <td
            v-if="!isLink(value)"
            class="pr-2"
            :class="{ 'font-bold': !isPdfPage }"
            :style="isPdfPage ? 'width:50%;' : undefined"
          >
            {{ label }}:
          </td>
          <td
            :style="isPdfPage ? 'width:50%;' : undefined"
            :colspan="isPdfPage || isLink(value) ? 1 : 2"
          >
            <template
              v-for="(text, index) in Array.isArray(value) ? value : [value]"
              :key="`${text}-text`"
            >
              <SectionsDetailsElementsText
                v-if="Array.isArray(text)"
                :label="text[0]"
                :text="text[1]"
              />
              <SectionsDetailsElementsText v-else :label="label" :text="text" />
              <br v-if="Array.isArray(value) && index < value.length - 1">
            </template>
          </td>
        </tr>
      </template>
      <slot name="after" />
    </tbody>
  </table>
</template>
